<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-add-map-layout-dialog"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title
        class="headline white--text"
        primary-title
      >{{$t('lbl.customerDataAnalysis.EDIFileUploadPopUp.page_header')}}</v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <!-- [E]  Popup title-->
    <v-card class="dialog-container">
      <!-- [S]  Popup body-->
      <v-card-text class="pb-0">
        <v-form ref="form" class="dialog-content">
          <v-row class="ml-0 mr-0">
            <v-col class="required-col field-col pt-0" lg="2">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span
                class="field-label required-text pl-1"
              >{{$t('lbl.customerDataAnalysis.EDIFileUploadPopUp.addEdiFile')}}</span>
            </v-col>
            <v-col class="map-text-field inline-block-component pl-0 pt-0" lg="10">
              <v-text-field
                v-model="contenInput"
                :rules="[validationUtils.required]"
                class="data-table-filter-text-field inline-block-component text-field-flatfile-layout flatfile-textfield"
                heigth="30"
                outlined
                dense
                solo
                readonly
              ></v-text-field>
              <input
                id="edifile"
                ref="edifile"
                @input="onFileChanged"
                type="file"
                style="display: none"
                accept=".tar, .gz, .jar, .zip, .edi"
              />
              <v-btn
                @click="clickBrowse()"
                class="btn btn-popup-search"
                color="primary"
              >{{$t('btn.common.browse')}}</v-btn>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="not-required-col field-col pb-0" lg="2">
              <span
                class="field-label required-text"
              >{{$t('lbl.customerDataAnalysis.EDIFileUploadPopUp.fileFormat')}}</span>
            </v-col>
            <v-col lg="3" class="map-text-field pl-0 pb-0">
              <v-select
                v-model="uploadData.data[0].EDI_TYPE"
                :rules="[validationUtils.required]"
                :items="editype"
                class="data-table-select-box srm-select-box custom-selectbox flatfile-layout-selectbox communication-select-box pt-0 pl-select"
                height="30"
                hide-details
                dense
                solo
                outlined
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
        <v-row class="ml-0 mr-0">
          <v-col class="button-col action-col" lg="12">
            <div class="btn-form-control text-right mr-4">
              <v-btn class="btn btn-delete" @click="removeDialog">
                <!-- <v-icon small color="white" class="mr-1">fa fa-times</v-icon> -->
                {{$t('btn.common.close')}}
              </v-btn>
              <v-btn class="btn btn-popup-search" color="primary" @click="uploadEDIData()">
                <!-- <v-icon x-small class="mr-2">fas fa-save</v-icon> -->
                {{$t('btn.customerDataAnalysis.EDIFileUploadPopUp.upload')}}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->
    </v-card>
    <!-- [E]  Popup button-->
    <dialogWindow
      ref="successDialog"
      size="max"
      title="Success"
      detail="The EDI file upload is in progress and may take some time. You can check the upload status at the top of this page or on the dashboard."
      color="success"
      @select-ok="onClickOkay"
    ></dialogWindow>
    <dialogWindow
      ref="acceptTypeDialog"
      size="max"
      title="Warning"
      detail="Acceptable extension:tar, gz, jar, zip, edi"
      color="warning"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */

import DialogDrag from "@/vue-dlb/components/vue-dialog-drag.vue";
import { mapState } from "vuex";
import { UploadFile } from "@/vue-dlb/models";
import dialogWindow from "@/vue-dlb/components/NewDialog.vue";
import IconSvg from "@/vue-caas/components/IconBase.vue";

import {
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress,
  alertSuccess,
  closeAlert,
} from "@/vue-dlb/utils/sys-util.js";

export default {
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
  },
  name: "edi-uploadfile-dialog",
  // props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd', 'queryList','callby'],
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    queryList: Function,
    callby: String,
  },
  computed: {
    ...mapState("common", {
      uploadedFile: "uploadedFile",
    }),
  },
  data() {
    return {
      successDialog: false,
      contenInput: "",
      editype: ["EDIFACT", "X12"],
      uploadData: {
        header: [
          "MST_CUST_ID",
          "MST_PRCS_STS",
          "EDI_TYPE",
          "UP_EDI_FILE",
          "FILE_NAME",
        ],
        data: [
          {
            MST_CUST_ID: "",
            MST_PRCS_STS: "",
            EDI_TYPE: "",
            UP_EDI_FILE: "",
            FILE_NAME: "",
          },
        ],
      },
    };
  },

  watch: {},

  methods: {
    uploadEDIData() {
      let validResult = this.$refs.form.validate();
      if (validResult) {
        console.log("--------- savaData ----------");
        if (!this.uploadData.data[0].EDI_TYPE) {
          showErrorMessage("Please select EDI TYPE");
          return;
        }

        if (this.$refs.edifile.files[0]) {
          let uploadfile = new UploadFile();
          uploadfile.data[0].DIV_KUBUN = "TEMP";
          uploadfile.data[0].BIZ_KUBUN = "EDIZIP";
          uploadfile.data[0].SITE_CODE = $cookies.get("comp-id");
          uploadfile.data[0].USER_KUBUN = $cookies.get("user-id");
          uploadfile.data[0].SUB_DIR = new Date().toFormat("YYYYMMDDHH24MISS");
          uploadfile.data[0].RENAME_YN = "N";
          uploadfile.data[0].FILE_NAME = this.$refs.edifile.files[0].name;
          uploadfile.data[0].file = this.$refs.edifile.files[0];

          Store.dispatch("common/UploadFileToServer", uploadfile).then(() => {
            this.uploadData.data[0].MST_CUST_ID = $cookies.get("comp-id");

            if (this.callby == "ANALYSIS")
              this.uploadData.data[0].MST_PRCS_STS = "INIT";
            // or 'UPLD'/ 이 Dialog를 어디서 호출하는지에 따라 바뀜.
            else if (this.callby == "MATCHING")
              this.uploadData.data[0].MST_PRCS_STS = "UPLD"; // or 'UPLD'/ 이 Dialog를 어디서 호출하는지에 따라 바뀜.

            if (this.$refs.edifile.files[0]) {
              this.uploadData.data[0].FILE_NAME = this.$refs.edifile.files[0].name;
              this.uploadData.data[0].UP_EDI_FILE = this.uploadedFile[0].FILE_NAME; // Server file path id
            }

            Store.dispatch("common/importEDIData", this.uploadData);
            this.$refs.successDialog.dialog = true;
          });
        }
      }
      return validResult;
    },
    onClickOkay() {
      this.removeDialog({});
    },
    clickBrowse() {
      this.$refs.edifile.click();
    },
    onFileChanged(e) {
      this.contenInput = e.target.files[0].name;
      let checkType = this.contenInput.split(".");
      let acceptType = checkType[checkType.length - 1];
      if (
        acceptType != "tar" &&
        acceptType != "gz" &&
        acceptType != "jar" &&
        acceptType != "zip" &&
        acceptType != "edi"
      ) {
        this.contenInput = null;
        this.$refs.edifile.value = null;
        this.$refs.acceptTypeDialog.dialog = true;
        return;
      }
    },
    setFieldValidation() {
      let validResult = this.$refs.form.validate();
      if (validResult) {
        alert();
      }
      return validResult;
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },

  created() {
    this.contenInput = "";
    this.uploadData.data[0].EDI_TYPE = "EDIFACT";
  },
};
</script>

<style>
</style>
